import { Box, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import buttons from '../../styles/buttons.module.css';
import layout from '../../styles/layout.module.css';
import { useTranslation } from 'react-i18next';
const ArtworkControlButtons = ({ onFlip, onMirror, onCenter, onReset }) => {
    const { t } = useTranslation();
    const isFlipped = useSelector((state) => state.rootReducer.customLayer.isFlipped);
    const isMirrored = useSelector((state) => state.rootReducer.customLayer.isMirrored);
    const customArtworkControllers = useMemo(() => {
        return [
            {
                id: 'flip-action',
                title: t('artwork.button_flip'),
                isActive: isFlipped,
                action: () => {
                    onFlip();
                }
            },
            {
                id: 'mirror-action',
                title: t('artwork.button_mirror'),
                isActive: isMirrored,
                action: () => {
                    onMirror();
                }
            },
            {
                id: 'center-action',
                title: t('artwork.button_center'),
                isActive: false,
                action: () => {
                    onCenter();
                }
            },
            {
                id: 'reset-action',
                title: t('artwork.button_reset'),
                isActive: false,
                action: () => {
                    onReset();
                },
                isReset: true
            }
        ];
    }, [isFlipped, isMirrored, onFlip, onMirror, onCenter, onReset]);

    return (
        <Box className={layout.artworkControllerContainer}>
            {customArtworkControllers.map((item) => {
                return (
                    <Button
                        key={item.id}
                        className={`${item.isActive ? buttons.btnPillActive : buttons.btnPill} ${
                            item.isReset && buttons.bgRed
                        }`}
                        onClick={() => {
                            item.action();
                        }}>
                        {item.title}
                    </Button>
                );
            })}
        </Box>
    );
};

export default ArtworkControlButtons;
